import { Lock, PencilLine } from "lucide-react";
import { Pill } from "./ui";

export function EstimateStatusPill({ status }) {
  if (status === "FINALIZED") {
    return (
      <Pill tone="success">
        <Lock size={10} aria-hidden="true" /> Finalized
      </Pill>
    );
  }
  return (
    <Pill tone="warning">
      <PencilLine size={10} aria-hidden="true" /> Draft
    </Pill>
  );
}

const CONFIDENCE_TONE = { High: "success", Medium: "info", Low: "warning", None: "neutral" };

export function ConfidenceBadge({ confidence }) {
  return (
    <Pill tone={CONFIDENCE_TONE[confidence] || "neutral"} dot>
      {confidence}
    </Pill>
  );
}

/**
 * "Prototype – mock data" marker on every estimate page: a slim vertical tab on
 * the right edge (click-through) so it never covers sticky footers or totals.
 */
export function PrototypeBadge() {
  return (
    <div
      className="pointer-events-none fixed right-0 top-1/2 z-[60] -translate-y-1/2 rotate-180 rounded-r-[4px] border border-l-0 border-warning_border bg-warning_bg px-1 py-2.5 text-[10.5px] font-semibold text-warning shadow-sm [writing-mode:vertical-rl]"
      role="note"
    >
      Prototype – mock data
    </div>
  );
}
